export const InvoiceRoute = {
  Invoice: (): string => '/invoice/cart',
  CartCoupon: (): string => '/invoice/cart/coupon',
};
